import React, { useState } from 'react'

import Edit from '../Edit/'

function DevItem ({ item, items, setItems }) {
  const [editing, setEditing] = useState(false)

  const toggleOpen = () => setEditing(!editing)


  function cb ({ url }) {
    const secret = window.location.search.match(/SECRET=(\w)*/gi)
    setEditing(false)
    console.log(item, url)
    fetch(`http://localhost:5000/edit?${secret}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ title: item.title, url })
    })
    .then(res => res.json())
    .then(res => {
      if (res.success) {
        const idx = items.indexOf(item)
        const newItems = [...items]
        newItems[idx].thumbnail = url
        setItems(newItems)
      } else {
        console.log(res)
      }
    })
    .catch(console.error)
  }

  return (
    <>
      <button className='devItem' onClick={toggleOpen}>
        <div className="project">
          <img src={item.thumbnail} className='project__background' alt='background' />
        </div>
        <p className='dev_title'>{ item.title }</p>
      </button>
      {editing ? <Edit cb={cb} /> : ''}
    </>
  )
}

export default DevItem
